import React, { Component } from 'react';
import { connect } from 'react-redux';

import ContentsHistoryItem from './ContentsHistoryItem';
import CustomizedDialog from '../Dialog/CustomizedDialog';
import Pagination from '../Common/Pagination';
import { alertActions } from '../../modules/alert';
import { boardService } from '../../services';


class ContentsHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contentsLogs: "",
            totalCount: 1,
            totalPage: 1,
            currentPage: 1,
            start: 1,
            open: false
        }
    }

    setContetsLogs = () => {
        let formData = new FormData();
        formData.append('siteID', this.props.siteID);
        formData.append('boardTypeCode', this.props.boardTypeCode);
        formData.append('listCount', 10);
        formData.append('currentPage', this.state.currentPage);
        boardService.getBoardRecords(formData)
            .then(response => {
                this.setState({
                    contentsLogs: response.data.adminLogList,
                    totalCount: response.data.totalCount,
                    totalPage: response.data.totalPage,
                    currentPage: response.data.currentPage,
                    start: response.data.start
                });
            })
            .catch(this.handleErrors)
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            currentPage: currentPage
        }, () => { this.setContetsLogs(); })
    };

    handleClickOpen = () => {
        this.setContetsLogs();
        this.setState({
            currentPage: 1,
            open: true
        });
    };
    handleClose = () => {
        this.setState({
            contentsLogs: "",
            open: false
        });
    };

    render() {
        const { isMobile } = this.props;
        const { contentsLogs, totalCount, start, open } = this.state;

        return (
            <>
                <button className="button w122-button white-button" style={{ width: isMobile ? '86px' : '98px' }} name="수정기록조회" onClick={this.handleClickOpen}>수정기록조회</button>
                <CustomizedDialog title={"수정기록조회"} open={open} handleClose={this.handleClose}>
                    <div className="dialog-content">
                        <div style={{ overflow: 'auto' }}>
                            <table style={{ width: isMobile ? '500px' : '100%' }}>
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: isMobile ? "30%" : "20%" }} />
                                    <col style={{ width: isMobile ? "35%" : "50%" }}/>
                                    <col style={{ width: isMobile ? "25%" : "20%" }} />
                                </colgroup>
                                <thead className="table-head">
                                    <tr>
                                        <th className="table-head-cell">NO</th>
                                        <th className="table-head-cell">날짜/시간</th>
                                        <th className="table-head-cell">수정내용</th>
                                        <th className="table-head-cell">작성자</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {(contentsLogs && contentsLogs.length > 0)
                                        ?
                                        contentsLogs.map((history, i) => {
                                            return <ContentsHistoryItem key={i} no={totalCount - (start + i) + 1} history={history} />;
                                        })
                                        :
                                        //  <!-- 입력된 로그가 없을 경우 -->
                                        <tr>
                                            <td colSpan="4" className="text-align-center">입력된 로그가 없습니다.</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <Pagination list={this.state} getCurrentPage={this.getCurrentPage} />
                    </div>

                </CustomizedDialog>
            </>
        );
    }
}



function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsHistory);